module.exports = __webpack_public_path__ + "img/class-banner_bg.0526268.png";